<section class="d-flex flex-column gap-32">
  <h1 class="access-restricted-title" i18n>Access Restricted</h1>
  <div class="d-flex flex-column gap-3 align-items-start">
    <p class="access-restricted-message" i18n>
      Your access to the member portal has been restricted.
      <a class="access-restricted-contact-link" [href]="contactUrl" target="_blank" rel="noopener">Contact</a> SPP for
      help.
    </p>
    <app-tertiary-button [size]="BaseButtonSizeEnum.xs" (buttonClicked)="backToLogIn()" i18n>
      Back to Log In
    </app-tertiary-button>
  </div>
</section>
